import { render, staticRenderFns } from "./shicigame.vue?vue&type=template&id=2de78506&scoped=true"
import script from "./shicigame.vue?vue&type=script&lang=js"
export * from "./shicigame.vue?vue&type=script&lang=js"
import style0 from "./shicigame.vue?vue&type=style&index=0&id=2de78506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de78506",
  null
  
)

export default component.exports